// extracted by mini-css-extract-plugin
export default {"pager":"Pager_pager__b5BBV","pager__info":"Pager_pager__info__rkvhR","btnLight":"Pager_btnLight__X8lfU"};